import React, { useState, useEffect } from "react"
import { FormattedMessage, defineMessages } from "react-intl"

import HomeVideo from "../../videos/home-bg-video.mp4"
import Link from "../../link"
import employerHero from "../../../static/assets/images/employers-hero.jpeg"
import educatorHero from "../../../static/assets/images/educators-hero.jpeg"
import { StaticImage } from "gatsby-plugin-image"
import SimpleLocalize from "../SimpleLocalize"

defineMessages({
  "home.title": {
    id: "home.title",
    defaultMessage:
      "We change the way a new generation finds their dream career",
  },
  "home.subtitle": {
    id: "home.subtitle",
    defaultMessage:
      "Where students reimagine their futures and employers attract a new generation of workers",
  },
  "home.cta": {
    id: "home.cta",
    defaultMessage: "",
  },
  "employers.title": {
    id: "employers.title",
    defaultMessage: "Use storytelling to attract talent and fuel diversity",
  },
  "employers.subtitle": {
    id: "employers.subtitle",
    defaultMessage:
      "Get a new generation of workers hired and placed into jobs so you can innovate and grow",
  },
  "employers.cta": {
    id: "employers.cta",
    defaultMessage: "Get Started",
  },
  "educators.title": {
    id: "educators.title",
    defaultMessage: "Empower your students to find the right career for them",
  },
  "educators.subtitle": {
    id: "educators.subtitle",
    defaultMessage:
      "An immersive career platform that uses storytelling for self-discovery, career exploration, and lifelong success",
  },
  "educators.cta": {
    id: "educators.cta",
    defaultMessage: "Request a Demo",
  },
})

const pages = {
  home: {
    image:
      "https://firebasestorage.googleapis.com/v0/b/lucid-bond-288217.appspot.com/o/sign-up-pages%2Fedges-fixed.jpg?alt=media&token=64ecd80c-0449-4ef5-89de-eec28fbf7ef4",
  },
  employers: {
    image: "employers-hero.jpeg",
  },
  educators: {
    image: "educators-hero.jpeg",
  },
}

const PromoHero = props => {
  const { scrollToForm, page, isVideo, pageContext } = props

  const [isVideoLoading, setIsVideoLoading] = useState(true)

  const { messages } = pageContext

  const [bannerHeight, setBannerHeight] = useState("54px")

  const updateBannerHeight = () => {
    let banner = undefined
    if (typeof document !== "undefined") {
      banner = document.querySelector(".finalist-banner")
    }
    if (banner) {
      setBannerHeight(banner.offsetHeight)
    }
  }

  useEffect(() => {
    updateBannerHeight()
    window.addEventListener("resize", updateBannerHeight)
    return () => window.removeEventListener("resize", updateBannerHeight)
  }, [])

  return (
    <SimpleLocalize {...{ pageContext }}>
      <section
        key={`${page}-hero`}
        className="signup-hero"
        style={{
          backgroundImage: isVideo
            ? "none"
            : `url("/assets/images/${pages[page].image}")`,
          marginTop: bannerHeight,
        }}  
      >
        {isVideo && (
          <>
            <video
              autoPlay
              muted
              loop
              playsInline
              controls={false}
              key={`video-${page}`}
              style={{ 
                filter: "brightness(0.8)",  
                objectFit: "cover",
              }}
            >
              <source
                src={HomeVideo}
                type="video/mp4"
                key={`video-${page}-source`}
              />
              Your browser is not supported!
            </video>
          </>
        )}

        <div 
          className="inner inner-signup"
          style={{
            paddingTop: 0,
          }}
        >
          <div className="hero-content">
            {/* <h1 className="hero-title">{pages[page].title}</h1> */}
            <h1 className="hero-title">
              <FormattedMessage id={`${page}.title`} />
            </h1>

            <p className="hero-subtitle">
              {/* {intl.formatMessage(messages[`${page}.subtitle`])} */}
              <FormattedMessage id={`${page}.subtitle`} />
              {/* {pages[page].subTitle} */}
            </p>

            {isVideo ? (
              <>
                <Link to={"/signup/educators"}>
                  <button
                    type="button"
                    className="button component-button component-button-default hero-button"
                    style={{ marginRight: "1rem", backgroundColor: "#74e4fb" }}
                  >
                    <FormattedMessage
                      id="footer-educators"
                      defaultMessage="Educators"
                    />
                  </button>
                </Link>
                <Link to={"/signup/employers"}>
                  <button
                    type="button"
                    className="button component-button component-button-default hero-button"
                    style={{
                      color: "#ffffff",
                      background: "#74e4fb12",
                      border: "2px solid #74e4fb",
                    }}
                  >
                    <FormattedMessage
                      id="footer-employers"
                      defaultMessage="Employers"
                    />
                  </button>
                </Link>
              </>
            ) : (
              <button
                type="button"
                style={{ backgroundColor: "#74e4fb" }}
                className="button component-button component-button-default hero-button"
                onClick={scrollToForm}
              >
                <FormattedMessage id={`${page}.cta`} />
              </button>
            )}
          </div>
        </div>
      </section>
    </SimpleLocalize>
  )
}

export default PromoHero
